/** Convert limited HTML into a single-line plain-text string for JSON-LD. */
export function toPlainText(html?: string | null): string | undefined {
if (!html) return undefined;
return html
.replace(/<\/(script|style)>[\s\S]*?<\/(script|style)>/gi, " ")
.replace(/<[^>]+>/g, " ")
.replace(/&nbsp;/g, " ")
.replace(/&amp;/g, "&")
.replace(/&quot;/g, '"')
.replace(/&#39;/g, "'")
.replace(/&lt;/g, "<")
.replace(/&gt;/g, ">")
.replace(/\s+/g, " ")
.trim();
}